import { CalendarTab } from "@/components/dashboard/shared/CalendarTab";

export default function LenderCalendar() {
  return <CalendarTab showAvailabilitySettings={true} />;
}